import type { SupportedLanguage } from './index'

export const localeByLanguage: Record<SupportedLanguage, string> = {
  nl: 'nl-NL',
  en: 'en-GB',
}
